import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Input, Text, Button, ErrorMsg } from "@fragments";

import { EmojiEventsRounded } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

import {
    AssetCategory,
    CommunityAssetImageField,
} from "@features/uploadAsset";

export default function Awards({
    configRef,
    communityId,
    onUploadingChange,
    errors = {},
    clearError = () => {},
}) {
    const { t } = useTranslation("groupModals");
    const [awards, setAwards] = useState(configRef.current.awards || []);

    useEffect(() => {
        configRef.current.awards = [...awards];
    }, [awards]);

    function handleTitleInput(value, i) {
        const next = [...awards];
        next[i].title = value;
        setAwards(next);
        clearError(`awards.${i}.title`);
    }

    function handleBannerChange(url, i) {
        const next = [...awards];
        next[i].banner = url;
        setAwards(next);
        clearError(`awards.${i}.banner`);
    }

    function handleRemove(i) {
        const next = [...awards];
        next.splice(i, 1);
        setAwards(next);
        clearError(`awards.${i}`);
    }

    function handleAdd() {
        setAwards([...awards, { banner: "", title: "" }]);
    }

    return (
        <>
            <Text.h3
                value={t("manageGroup.awards.title")}
                className="mt-3"
                grow
                left={<EmojiEventsRounded />}
                right={
                    <Button
                        size="small"
                        color="overlay"
                        onClick={handleAdd}
                        icon={<AddIcon />}
                        tooltip={t("manageGroup.awards.add")}
                    />
                }
            />

            {awards.map((award, i) => {
                const awardErrors = errors?.awards?.[i];
                return (
                    <div className="award-row mt-2" key={i}>
                        <CommunityAssetImageField
                            communityId={communityId}
                            category={AssetCategory.GROUP_AWARD}
                            value={award.banner}
                            onChange={(url) => handleBannerChange(url, i)}
                            onUploadingChange={onUploadingChange}
                            aspectRatio={1}
                            size={40}
                            imageMaxWidth={360}
                            title={t("manageGroup.awards.bannerTitle")}
                            displayTitle={false}
                        />
                        <Input
                            placeholder={t("manageGroup.awards.titlePlaceholder")}
                            className="counter-input fade delay-1"
                            value={award.title || ""}
                            onInput={(e) => handleTitleInput(e, i)}
                            color="primary"
                            InputLabelProps={{ shrink: true }}
                            error={!!awardErrors?.title}
                            fullWidth
                        />
                        <Button
                            size="small"
                            onClick={() => handleRemove(i)}
                            icon={<DeleteIcon />}
                            color="overlay"
                        />
                        {(awardErrors?.title || awardErrors?.banner) && (
                            <div style={{ flexBasis: "100%" }}>
                                {awardErrors?.banner && (
                                    <ErrorMsg>{awardErrors.banner}</ErrorMsg>
                                )}
                                {awardErrors?.title && (
                                    <ErrorMsg>{awardErrors.title}</ErrorMsg>
                                )}
                            </div>
                        )}
                    </div>
                );
            })}
        </>
    );
}
